"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SadFace = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _core = require("@emotion/core");

const SadFace = props => (0, _core.jsx)("svg", (0, _extends2.default)({
  width: "80",
  height: "80",
  viewBox: "0 0 80 80",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), (0, _core.jsx)("circle", {
  cx: "30",
  cy: "40",
  r: "30",
  fill: "#DFFFF2"
}), (0, _core.jsx)("path", {
  d: "M61.214 18.787a29.998 29.998 0 010 42.427 30 30 0 110-42.427M28.333 30v3.333M51.667 30v3.333",
  stroke: "#1F2D27"
}), (0, _core.jsx)("path", {
  d: "M28.333 53.333S32.71 48.96 40 48.96c7.293 0 11.666 4.373 11.666 4.373",
  stroke: "#1F2D27"
}));

exports.SadFace = SadFace;
SadFace.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SadFace"
};